import PropTypes from 'prop-types';

const makeModelYearShape = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  submodel: PropTypes.string,
};

export const FeaturesSpecsParams = PropTypes.shape(makeModelYearShape);

export const FeaturesSpecsMcpParams = makeModelYearShape;

const makeModelShape = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  submodel: PropTypes.string,
};

export const FeaturesSpecsMakeModelMcpParams = makeModelShape;
